<template>
    <!--这里使用key重置刷新组件,而不是v-if -->
    <div id="app" :key="source">
        <template>
            <vue-aliplayer-v2
                style="height:100%;"
                ref="VueAliplayerV2"
                id="player-1194076936807170050"
                :source="source"
                :options="options"
                @ended="onEnded"
                @completeSeek="onCompleteSeek"
            />
        </template>

    </div>
</template>
<script>
    import VueAliplayerV2 from 'vue-aliplayer-v2';
    import {getDefinitionUrlList} from "@/api/vod";

    export default {
        components: {VueAliplayerV2: VueAliplayerV2.Player},
        props: {
            vid: {
                type: String,
                default: ''
            },
            needLogin:true
        },
        data() {
            return {
                options: {
                    autoplay: true,
                    useH5Prism: true,
                },
                source: "",
                show: true,

            }
        },

        created() {
            this.fetchDefinitionList();
        },

        watch: {
            vid(oldVal, newVal) {
                this.fetchDefinitionList();
            },
        },


        methods: {

            fetchDefinitionList() {
                if (!this.vid) return;
                if(this.needLogin){
                     getDefinitionUrlList({video_id: this.vid}).then(rep => {
                        if (rep !== -1) {
                            this.source = JSON.stringify(rep);
                        } else {
                            this.$message("网络出错，请联系网站管理员");
                        }
                    });
                }
            },

            play() {
                this.$refs.VueAliplayerV2.play()
            },

            pause() {
                this.$refs.VueAliplayerV2.pause();
            },

            replay() {
                this.$refs.VueAliplayerV2.replay();
            },

            getCurrentTime() {
                return this.$refs.VueAliplayerV2.getCurrentTime();
            },
            getStatus() {
                return this.$refs.VueAliplayerV2.getStatus();
            },

            seek(time) {
                this.$refs.VueAliplayerV2.seek(time);
            },

            //视频播放完毕触发
            onEnded() {
                this.$emit("onend")
            },

            //完成拖拽
            onCompleteSeek(time) {
                this.$emit("oncompleteseek")
            },

        }
    }
</script>
<style lang="scss">
    * {
        margin: 0;
        padding: 0;
    }


    .prism-player .prism-info-display {
        padding: 0;
    }

    .remove-text {
        text-align: center;
        padding: 20px;
        font-size: 24px;
    }

    .player-btns {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        span {
            margin: 0 auto;
            display: inline-block;
            /*padding: 5px 10px;*/
            width: 150px;
            height: 40px;
            line-height: 40px;
            border: 1px solid #eee;
            background: #e1e1e1;
            border-radius: 10px;
            text-align: center;
            margin: 5px;
            cursor: pointer;
        }
    }

    .source-box {
        /*padding: 5px 10px;*/
        margin-bottom: 20px;

        .source-label {
            margin-right: 20px;
            font-size: 16px;
            display: block;
        }

        #source {
            margin-top: 10px;
        }

        .source-input {
            margin-top: 10px;
            /*padding: 5px 10px;*/
            width: 80%;
            border: 1px solid #ccc;
        }
    }
</style>
